<template>
  <div class="layout-container page-main">
    <div class="page-panel profile-panel">
      <div class="page-head">
        <h1>个人中心</h1>
      </div>
      <div class="profile-body">
        <div class="avatar-wrap" @click="changeAvatar">
          <img :src="user.imgUrl" class="avatar" alt=""/>
          <div class="avatar-mask">更换头像</div>
        </div>
        <div class="profile-form">
          <label class="field-label">昵称</label>
          <input v-model="user.nickName" class="nickname-input" placeholder="输入昵称" maxlength="12"/>
          <button class="btn-primary save-btn" @click="saveProfile">保存资料</button>
        </div>
      </div>
      <input type="file" ref="fileInput" accept="image/*" hidden @change="onFileChange"/>
    </div>
  </div>
</template>

<script>
import { upload, updateUserInfo, getUserInfo } from '@/utils/http'
import { bus } from '@/utils/bus'

export default {
  name: 'Profile',
  data() {
    return {
      user: { imgUrl: 'https://via.placeholder.com/150', nickName: '' }
    }
  },
  async created() {
    const cache = localStorage.getItem('user')
    if (cache) {
      this.user = JSON.parse(cache)
    } else {
      const res = await getUserInfo()
      this.user = res.data
    }
  },
  methods: {
    changeAvatar() {
      this.$refs.fileInput.click()
    },
    async onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        const res = await upload(formData)
        this.user.imgUrl = res.data.url
        localStorage.setItem('user', JSON.stringify(this.user))
      }
    },
    async saveProfile() {
      const res = await updateUserInfo({
        id: this.user.id,
        imgUrl: this.user.imgUrl,
        nickName: this.user.nickName
      })
      if (res.status && res.status === 200) {
        localStorage.setItem('user', JSON.stringify(this.user))
        bus.$emit('login-success', this.user)
        this.$alert('保存成功', '提示', { confirmButtonText: '确定', center: true, type: 'success' })
            .then(() => { this.$router.push('/index') })
      } else {
        this.$alert(res.message, '提示', { confirmButtonText: '确定', center: true })
      }
    }
  }
}
</script>

<style scoped>
.profile-panel {
  max-width: 520px;
  margin: 0 auto;
}

.profile-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.avatar-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid var(--border);
  margin-bottom: 28px;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.avatar-wrap:hover .avatar-mask {
  opacity: 1;
}

.profile-form {
  width: 100%;
}

.field-label {
  display: block;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.nickname-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 15px;
  margin-bottom: 20px;
  box-sizing: border-box;
  background: var(--surface-2);
  color: var(--text);
}

.nickname-input:focus {
  outline: none;
  border-color: var(--tx-accent);
}

.save-btn {
  width: 100%;
  height: 44px;
}
</style>
